import NTopNBottom from '../../components/NTopNBottom'

import bannerImg from '../../assets/autumnFlower2022/banner.jpg'
import navColor from '../../assets/autumnFlower2022/nav/color.jpg'
import navBg from '../../assets/autumnFlower2022/nav/nav_bg.png'
import navBgFixed from '../../assets/autumnFlower2022/nav/nav_bg_fixed.png'

import calcRemFn from '../calcRem'

const navCss = {
  navWrap: {
    paddingTop: 0,
    minHeight: calcRemFn(212),
    backgroundImage: `url(${navColor})`,
  },
  navCtn: {
    height: calcRemFn(212),
    backgroundImage: `url(${navBg})`,
  },
  navCtnFixed: {
    height: calcRemFn(212),
    backgroundImage: `url(${navBgFixed})`,
  },
  topBtnLayout: {
    alignItems: 'center',
    padding: `${calcRemFn(13.5)} ${calcRemFn(96)} 0 ${calcRemFn(95)}`
  },
  topBtnBaseCss: {
    width: calcRemFn(62.5),
    height: calcRemFn(56.5),
  },
  bottomBtnLayout: {
    flexWrap: 'wrap',
    justifyContent: 'center',
    padding: `${calcRemFn(4)} ${calcRemFn(21.5)} 0`,
  },
  bottomBtnBaseCss: {
    width: calcRemFn(62.5),
    height: calcRemFn(26.5),
  }
}


const navData = {
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
      prodId: '27203',
      picNum: [4, 2, 3, 2, 2, 2, 2, 2, 1, 2, 2, 1, 1],
    },
    {
      key: 'top2',
      show: true,
      prodId: '27378',
      picNum: [3, 2, 2, 2, 2, 2, 2, 2, 2, 1, 2, 1, 2]
    },
    {
      key: 'top3',
      show: true,
      prodId: '27379',
      picNum: [3, 1, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1]
    }
  ],
  bottom: {
    top1: [],
    top2: [],
    top3: []
  },
}
let sonTmp1 = new Array(13).fill(1)

navData.top = navData.top.map((item, index) => {
  item.img = require(`../../assets/autumnFlower2022/nav/far${index + 1}.png`)
  item.img_actived = require(`../../assets/autumnFlower2022/nav/far${index + 1}_active.png`)
  return item
})

sonTmp1.forEach((item, index) => {
  let flag = index + 1
  navData.bottom.top1.push({
    key: '_i' + flag,
    show: true,
    img: require(`../../assets/autumnFlower2022/nav/son${flag}.png`),
    img_actived: require(`../../assets/autumnFlower2022/nav/son${flag}_active.png`),
  })
  navData.bottom.top2.push({
    key: '_i' + flag,
    show: true,
    img: require(`../../assets/autumnFlower2022/nav/son${flag}.png`),
    img_actived: require(`../../assets/autumnFlower2022/nav/son${flag}_active.png`),
  })
  navData.bottom.top3.push({
    key: '_i' + flag,
    show: true,
    img: require(`../../assets/autumnFlower2022/nav/son${flag}.png`),
    img_actived: require(`../../assets/autumnFlower2022/nav/son${flag}_active.png`),
  })
})

function handlePictures () {
  const pictures = []
  navData.top.forEach((item, index) => {
    const { picNum, key } = item

    picNum.forEach((ele, eleIndex) => {
      const picList = []
      Array(ele).fill(0).forEach((ele2, eleIndex2) => {
        picList.push(require(`../../assets/autumnFlower2022/ctn/${index + 1}_${eleIndex + 1}_${eleIndex2 + 1}.jpg`))
        if (ele === (eleIndex2 + 1)) {
          pictures.push({
            id: item.prodId,
            type: 'gold',
            ref: `${key}_i${eleIndex + 1}`,
            farName: `${key}`,
            sonName: `_i${eleIndex + 1}`,
            son: picList
          })
        }
      })
    })

  })

  return pictures
}

const pictures = handlePictures()

pictures.push({
  son: [
    require(`../../assets/autumnFlower2022/ctn/end.jpg`),
  ]
})

const topDiff = {
  firstSon: '_i1',
  top1_i1: 35,
  top1_i2: 20,
  top1_i3: 20,
  top1_i4: 20,
  top1_i5: 20,
  top1_i6: 20,
  top1_i7: 20,
  top1_i8: 20,
  top1_i9: 20,
  top1_i10: 20,
  top1_i11: 20,
  top1_i12: 20,
  top2_i1: 48,
  top2_i2: 20,
  top2_i3: 20,
  top2_i4: 20,
  top2_i5: 20,
  top2_i6: 20,
  top2_i7: 20,
  top2_i8: 20,
  top2_i9: 20,
  top2_i10: 20,
  top2_i11: 20,
  top2_i12: 20,
  top2_i13: 20,
  top3_i1: 48,
  top3_i2: 20,
  top3_i3: 20,
  top3_i4: 20,
  top3_i5: 20,
  top3_i6: 20,
  top3_i7: 20,
  top3_i8: 20,
  top3_i9: 20,
  top3_i10: 20,
  top3_i11: 20,
  top3_i12: 20,
  top3_i13: 20,
}

export default {
  title: '花颜照',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff
}
